import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { fetchActivePrescriptions } from './api';

/**
 * Replaces useTodayPrescriptions.ts — that hook read approved AI-drafted
 * consultation documents, which carry no per-item quantity or dispense
 * status, so a sale against one could never be linked back to what was
 * actually prescribed. This reads the structured `prescriptions` table
 * instead (branch-scoped), and a prescription drops off this list on its
 * own once every item is fully dispensed — see billing.js's auto-complete
 * step in POST /pharmacy/create, not a client-side filter here.
 */
export function useActivePrescriptions() {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.prescriptions.list({ status: 'active' }), branchVersion],
    queryFn: fetchActivePrescriptions,
  });
}
